<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M4 21v-.88h2.5v-1.37H5v-.88h1.5V16.5H4v-.88h2.7q.28 0 .49.2t.2.49v1.38q0 .3-.2.5t-.5.2q.3 0 .5.2t.2.49v1.23q0 .3-.2.5-.2.19-.5.19zm0-6.3v-2.45q0-.3.2-.5t.5-.2h1.8V10.2H4v-.88h2.7q.28 0 .49.2t.2.49v1.75q0 .3-.2.5t-.5.2H4.9v1.36h2.5v.88zm1.5-6.32v-4.5H4V3h2.38v5.38zM9.62 18.5v-1H20v1zm0-6v-1H20v1zm0-6v-1H20v1z"
      />
    </svg>
  </span>
</template>
